export const usdFormat = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });